import getReportingOption from '../store/store';
import { mutator } from 'satcheljs';
import { setReportingState } from '../actions/internalActions';

mutator(setReportingState, actionMessage => {
    const reportingOption = getReportingOption();
    reportingOption.checkForReportJunkDialog =
        actionMessage.reportingState.checkForReportJunkDialog;
    reportingOption.reportJunkSelected = actionMessage.reportingState.reportJunkSelected;
});
